<template>
  <footer>
    <div class="container p-4">
      <div class="row row-cols-1 row-cols-lg-5">
        <div class="col logotipo"><a href="https://www.rimborsoalvolo.it/customers/it/flightsub?aeropuid=undefined&aeroduid=undefined"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/logtipoRavBianco.svg"></a></div>
        <div class="col link"><a href="https://www.rimborsoalvolo.it/informativa-sulla-privacy/" class="foolink" target="_blank">Privacy Policy</a></div>
        <div class="col link"><a href=https://www.iubenda.com/privacy-policy/90803466/cookie-policy target="_blank" class="foolink">Cookie Policy</a></div>
        <div class="col link"><a href="https://www.rimborsoalvolo.it/termini-e-condizioni-di-servizio/" class="foolink">Termini e condizioni</a></div>
        <div class="col">
          <div class="row iconeSocial align-items-center">
            <div class="col text-end"><a href="https://www.facebook.com/rimborsoalvolo" target="_blank"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/facebook.png"></a></div>
            <div class="col text-center"><a href="https://www.instagram.com/rimborsoalvolo.it/" target="_blank"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/instagram.png"></a></div>
            <div class="col text-start"><a href="https://www.youtube.com/channel/UCmG8RqK8TqDxkHW92ZS-iEQ" target="_blank"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/youtube.png"></a></div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter"
}
</script>

<style scoped>

</style>